import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Loader2, Gift } from 'lucide-react';

/**
 * Referral system settings component
 * Now uses INR (₹) instead of Millis for reward amount
 */
export const ReferralSettings = ({
  referralSettings,
  newReferralReward,
  setNewReferralReward,
  referralLoading,
  canEdit,
  onUpdateReward
}) => {
  return (
    <Card className="mb-6 border-green-200 bg-green-50/30">
      <CardHeader>
        <CardTitle className="font-serif text-lg text-green-700 flex items-center gap-2">
          <Gift className="w-5 h-5" />
          Referral System Settings
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm text-muted-foreground mb-2">Referral Statistics</p>
            <div className="grid grid-cols-3 gap-3">
              <div className="text-center p-3 bg-white rounded-lg border border-green-200">
                <p className="text-xl font-bold text-navy">{referralSettings?.stats?.total_referrals || 0}</p>
                <p className="text-xs text-muted-foreground">Total</p>
              </div>
              <div className="text-center p-3 bg-white rounded-lg border border-green-200">
                <p className="text-xl font-bold text-green-600">{referralSettings?.stats?.completed_referrals || 0}</p>
                <p className="text-xs text-muted-foreground">Completed</p>
              </div>
              <div className="text-center p-3 bg-white rounded-lg border border-green-200">
                <p className="text-xl font-bold text-navy">{referralSettings?.stats?.total_rewards_given || 0}</p>
                <p className="text-xs text-muted-foreground">Millis Given</p>
              </div>
            </div>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-2">Reward per Referral (in ₹)</p>
            <div className="flex gap-3">
              <div className="relative flex-1">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">₹</span>
                <Input
                  type="number"
                  value={newReferralReward}
                  onChange={(e) => setNewReferralReward(e.target.value)}
                  placeholder="50"
                  className="pl-7"
                  min="0"
                  max="500"
                  disabled={!canEdit()}
                />
              </div>
              <Button
                onClick={onUpdateReward}
                disabled={referralLoading || !canEdit()}
                className="bg-green-600 hover:bg-green-700 text-white"
              >
                {referralLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Update'}
              </Button>
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              Current reward: <span className="font-semibold">₹{referralSettings?.reward_inr || referralSettings?.reward_millis || 50} worth of gold</span> per successful referral
            </p>
            <p className="text-xs text-green-600 mt-1">
              Both referrer and referee receive this amount converted to Millis at current gold rate
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralSettings;
